import { Clinic } from "@ambii-com/core";
import { liteCollections, liteGetDocument } from "~/utils/firestoreLite";

export async function readClinic(clinicId: string): Promise<Clinic> {
  return liteGetDocument(liteCollections.clinics, clinicId).then(Clinic.fromDoc);
}
